import Spinner from 'components/Spinner';
import styles from './RouteChunkFallback.module.scss';

const RouteChunkFallback = () => (
  <div className={styles.wrapper} role="status" aria-live="polite" aria-label="Loading page">
    <Spinner />
  </div>
);

export default RouteChunkFallback;
